import React, {Suspense} from "react";
import {BrowserRouter, Routes, Route} from "react-router-dom";

import ProtectedRoute from "./middleware/ProtectRoute";

import {ProjectsProvider} from "./context/ProjectsContext";
import {FavoritesProvider} from "./hooks/useFavorites";
import {PagesProvider} from "./context/PagesContext";
import {ServicesProvider} from "./context/ServiceContext";
import {NotificationsProvider} from "./components/Notification/UseNotifications";
import {ReviewsProvider} from './context/ReviewsContext';

import Layout from "./components/Layout/Layout";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import LoadingSpinner from "./components/LoadingSpinner/LoadingSpinner";

// Ленивая загрузка ВСЕХ страниц
const Home = React.lazy(() => import("./pages/Home"));
const Services = React.lazy(() => import("./pages/Services/Services"));
const Projects = React.lazy(() => import("./pages/Projects/Projects"));
//const Favorites = React.lazy(() => import("./pages/Favorites/Favorites"));
const Admin = React.lazy(() => import("./pages/Admin/Admin"));
const NotFound = React.lazy(() => import("./pages/NoFound/NotFound"));
const ConcretService = React.lazy(() => import("./pages/ConcretService/ConcretService"));
const ConcretProject = React.lazy(() => import("./pages/ConcretProject/ConcretProject")); // ← ИСПРАВЛЕНО
const AdminDashboard = React.lazy(() => import("./pages/AdminDashboard/AdminDashboard"));
const AboutCompany = React.lazy(() => import("./pages/AboutCompany/AboutCompany"));
const Process = React.lazy(() => import("./pages/Process/Process"));
const Reviews = React.lazy(() => import("./pages/Reviews/Reviews"));
const Contacts = React.lazy(() => import("./pages/Contacts/Contacts"));

const pages = [
    {path: "/", element: <Home/>},
    {path: "/services", element: <Services/>},
    {path: "/projects", element: <Projects/>},
    // {path: "/favorites", element: <Favorites/>},
    {path: "/admin", element: <Admin/>, hideForm: true},
    {path: "/services/:id", element: <ConcretService/>},
    {path: "/projects/:id", element: <ConcretProject/>},
    {
        path: "/admin/dashboard",
        element: (
            <ProtectedRoute>
                <AdminDashboard />
            </ProtectedRoute>
        ),
        hideForm: true,
    },
    {path: "/about", element: <AboutCompany/>},
    {path: "/process", element: <Process/>},
    {path: "/reviews", element: <Reviews/>},
    {path: "/contacts", element: <Contacts/>},
    {path: "*", element: <NotFound/>, hideForm: true},
];

function App() {
    return (
        <NotificationsProvider>
            <PagesProvider>
                <ServicesProvider>
                    <ProjectsProvider>
                        <FavoritesProvider>
                            <ReviewsProvider>
                                <BrowserRouter>
                                    <ScrollToTop/>
                                    <Suspense fallback={<LoadingSpinner/>}>
                                        <Routes>
                                            {pages.map(({path, element, hideForm}) => (
                                                <Route
                                                    key={path}
                                                    path={path}
                                                    element={<Layout hideForm={hideForm}>{element}</Layout>}
                                                />
                                            ))}
                                        </Routes>
                                    </Suspense>
                                </BrowserRouter>
                            </ReviewsProvider>
                        </FavoritesProvider>
                    </ProjectsProvider>
                </ServicesProvider>
            </PagesProvider>
        </NotificationsProvider>
    );
}

export default App;